import React from "react";
import { GridCell } from "@progress/kendo-react-grid";
import { Tooltip } from "@progress/kendo-react-tooltip";
import {
  ConservacionMensajeImage,
  EstampadoTiempoImage,
} from "../../../assets/logos/icons";
import { withTranslation } from 'react-i18next'
import { EFirmaImage, FirmaAvanzadaImage } from "../../../assets/logos";

function cellDetailAditionalServices() {

  class CellComponent extends GridCell {
    render() {
      const { solicitudeAdditionalData, inboxType, inboxTypeIcon, signatureTypeId, inboxTypeTooltip, solicitudeHasMultipleSignatures, proofOfLife } = this.props.dataItem
      const { t } = this.props
      let signatureType = {
        signatureTypeName: "",
        signatureTypeIcon: ""
      }
      if (signatureTypeId) {
        switch (signatureTypeId) {
          case 1:
            signatureType.signatureTypeIcon = EFirmaImage
            break
          case 2:
            signatureType.signatureTypeIcon = FirmaAvanzadaImage
            break;
          case 3:
            signatureType.signatureTypeIcon = inboxTypeIcon
            break
        }
      } else signatureType = { signatureTypeName: inboxType ?? "", signatureTypeIcon: inboxTypeIcon ?? null };
      if (inboxTypeTooltip) signatureType.signatureTypeName = inboxTypeTooltip
      const newServices =
        solicitudeAdditionalData === ""
          ? solicitudeAdditionalData.split("")
          : JSON.parse(solicitudeAdditionalData);

      return (
        <td className="cell-hide">
          <div style={{ display: "flex", alignItems: "center" }}>
            <Tooltip
              openDelay={600}
              position="top"
              anchorElement="target"
              tooltipClassName="tooltipGeneralStyle"
            >
              <span style={{ cursor: "pointer", marginRight: "10px" }}>
                {signatureType.signatureTypeIcon ? (
                  <img
                    src={
                      signatureType.signatureTypeIcon &&
                        solicitudeHasMultipleSignatures
                        ? `${process.env.REACT_APP_AWS_S3_BUCKET_URL}microservices/MiFirma/assets/inbox/iconoFirma2.svg`
                        : signatureType.signatureTypeIcon
                    }
                    title={t(`inbox.description.name.${inboxType}`, { defaultValue: inboxType })}
                    alt="imagen"
                    width={18}
                  />
                ) : null}
              </span>
            </Tooltip>
            {this.props.dataItem.proofOfLife &&
              <Tooltip
                openDelay={600}
                position="top"
                anchorElement="target"
                tooltipClassName="tooltipGeneralStyle"
              >
                <span style={{ cursor: "pointer", marginRight: "10px" }}>
                  <img
                    src={`${process.env.REACT_APP_AWS_S3_BUCKET_URL}microservices/MiFirma/assets/inbox/icono_prueba_de_vida.svg`}
                    title={process.env.REACT_APP_PROOF_OF_LIFE_NAME}
                    alt="imagen"
                    width={18}
                  />
                </span>
              </Tooltip>
            }
            {newServices.map((item, index) => {
              let serviceIcon;

              if (
                item ===
                Number(process.env.REACT_APP_ADDITIONAL_SERVICES_TIME_DOCUMENT)
              )
                serviceIcon = EstampadoTiempoImage;
              if (
                item ===
                Number(
                  process.env.REACT_APP_ADDITIONAL_SERVICES_MESSAGE_PRESERVATION
                )
              )
                serviceIcon = ConservacionMensajeImage;
              if (
                item ===
                Number(
                  process.env.REACT_APP_ADDITIONAL_SERVICES_TIME_BY_SIGNATURE
                )
              )
                serviceIcon = EstampadoTiempoImage;

              return (
                <React.Fragment key={String(index)}>
                  <Tooltip
                    openDelay={600}
                    position="top"
                    anchorElement="target"
                    tooltipClassName="tooltipGeneralStyle"
                  >
                    <span style={{ cursor: "pointer", marginRight: "10px" }}>
                      <img
                        src={serviceIcon}
                        title={
                          item === 2
                            ? "Constancia de conservación de mensajes"
                            : "Sello digital de tiempo por documento"
                        }
                        alt="imagen"
                        width={18}
                      />
                    </span>
                  </Tooltip>
                </React.Fragment>
              );
            })}
          </div>
        </td>
      );
    }
  }
  return withTranslation()(CellComponent)
}
export default cellDetailAditionalServices
